import React from 'react';
import { FloatingDropdown } from '../../../components/ui/FloatingDropdown';
import { CITY_CONFIG } from '../../../config/cityConfig';

interface Client {
	clientId: number;
	clientName: string;
}

interface SkuListingFiltersProps {
	clients: Client[];
	selectedClientId: number | null;
	selectedStatus: string;
	onClientChange: (clientId: string) => void;
	onStatusChange: (status: string) => void;
	/**
	 * Cross-city users (founders, type-4 finance) get an extra City picker
	 * inline. Passing these props in opts the page into 3-column layout.
	 * Non-cross-city users omit them — only Client + Status render.
	 */
	showCityPicker?: boolean;
	selectedCityId?: number | null;
	onCityChange?: (cityId: number | null) => void;
}

const CITY_OPTIONS = [
	{ value: '', label: 'All Cities' },
	{ value: String(CITY_CONFIG.cityIds.bangalore), label: 'Bangalore' },
	{ value: String(CITY_CONFIG.cityIds.mumbai), label: 'Mumbai' },
	{ value: String(CITY_CONFIG.cityIds.gurgaon), label: 'Gurgaon' },
	{ value: String(CITY_CONFIG.cityIds.hyderabad), label: 'Hyderabad' },
];

export const SkuListingFilters: React.FC<SkuListingFiltersProps> = ({
	clients,
	selectedClientId,
	selectedStatus,
	onClientChange,
	onStatusChange,
	showCityPicker = false,
	selectedCityId,
	onCityChange,
}) => {
	// When the City picker is active, lay out as 3 columns on desktop instead
	// of 2. Keeps the trio visually balanced — same height, same border, same
	// label-floating style — instead of dangling a stray dropdown above.
	const gridCols = showCityPicker
		? 'grid-cols-1 md:grid-cols-3'
		: 'grid-cols-1 md:grid-cols-2';

	return (
		<div className='bg-background rounded-lg border border-border p-4 mb-6'>
			<div className={`grid ${gridCols} gap-4`}>
				{showCityPicker && (
					<FloatingDropdown
						label='Select City'
						placeholder='All Cities'
						value={selectedCityId != null ? String(selectedCityId) : ''}
						onChange={v => onCityChange?.(v === '' ? null : Number(v))}
						options={CITY_OPTIONS}
					/>
				)}
				<FloatingDropdown
					label='Select Client'
					placeholder='Choose a client'
					value={selectedClientId?.toString() || ''}
					onChange={onClientChange}
					options={clients.map(client => ({
						value: client.clientId.toString(),
						label: client.clientName,
					}))}
				/>
				<FloatingDropdown
					label='Status'
					placeholder='Filter by status'
					value={selectedStatus}
					onChange={onStatusChange}
					options={[
						{ value: '', label: 'All' },
						{ value: 'Enabled', label: 'Enabled' },
						{ value: 'Disabled', label: 'Disabled' },
					]}
				/>
			</div>
		</div>
	);
};

